import cn from "classnames/bind";
import {Link, LogoCat} from "@/theme";

export const Logo = ({collapsed, setCollapsed}) => {
    return (
        <Link
            route={'users.index'}
            onClick={()=>{
                if (setCollapsed){
                    setCollapsed()
                }
            }}
        >
            <div className={cn('logo', {['collapsed']: collapsed})}>
                <LogoCat
                    showText={collapsed}
                />
            </div>
        </Link>
    );
}